// ============================================
// UI Store (Zustand)
// UI 상태 관리 (모달, 토스트, 로딩 등)
// ============================================

import { createStore } from 'zustand/vanilla';

export const useUIStore = createStore((set, get) => ({
  // ============================================
  // State
  // ============================================

  // 모달 상태
  activeModal: null,
  modalData: null,

  // 토스트 메시지
  toasts: [],

  // 전역 로딩
  globalLoading: false,
  loadingMessage: '',

  // 사이드바
  sidebarOpen: false,

  // ============================================
  // Actions - Modal
  // ============================================

  openModal: (modalName, data = null) => set({
    activeModal: modalName,
    modalData: data
  }),

  closeModal: () => set({
    activeModal: null,
    modalData: null
  }),

  // ============================================
  // Actions - Toast
  // ============================================

  addToast: (message, type = 'info', duration = 3000) => {
    const id = Date.now();
    set((state) => ({
      toasts: [...state.toasts, { id, message, type, duration }]
    }));

    // 자동 제거
    if (duration > 0) {
      setTimeout(() => {
        get().removeToast(id);
      }, duration);
    }

    return id;
  },

  removeToast: (id) => set((state) => ({
    toasts: state.toasts.filter(t => t.id !== id)
  })),

  clearAllToasts: () => set({ toasts: [] }),

  // ============================================
  // Actions - Loading
  // ============================================

  setGlobalLoading: (loading, message = '') => set({
    globalLoading: loading,
    loadingMessage: message
  }),

  // ============================================
  // Actions - Sidebar
  // ============================================

  toggleSidebar: () => set((state) => ({
    sidebarOpen: !state.sidebarOpen
  })),

  setSidebarOpen: (open) => set({ sidebarOpen: open })
}));

export default useUIStore;
